import React from 'react';
import { RouteInfoProps } from './types';
import { ArcCellInfo, ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { MissionIdParams } from '@src/core/entities';
import { useGetOrderMissionQuery } from '@src/features/order/redux';
import { OrderMissionEntity } from '@src/core/features';
import { arcSpatium, arcVelocitas } from '@src/core/extensions';
import { routesConfig } from '@src/core/routes';

const getOrderWP = (data: OrderMissionEntity) => {
  const orderWP = data.waypoints.find((w) => Boolean(w.orderId));
  return orderWP;
};

const getTakeOff = (data: OrderMissionEntity) => {
  const [wp] = data.waypoints;
  return wp;
};

const RouteInfo: React.FC<RouteInfoProps> = (props) => {
  const { missionId } = useParams<MissionIdParams>();
  const { missionId: propsMissionId } = props;
  const effectiveMissionId = propsMissionId || missionId;
  const navigate = useNavigate();
  const { data, isLoading } = useGetOrderMissionQuery(effectiveMissionId, { skip: !effectiveMissionId });
    
  if (isLoading || !data) return <ArcSkeleton height={250} />;
    
  const [order] = data?.orders ?? [];

  const orderWp = getOrderWP(data);
  const takeOffWp = getTakeOff(data);

  return (
    <ArcStack p={2} borderRadius={1} spacing={2} bgcolor='background.paper'>
      <ArcStack spacing={1} direction='row' justifyContent='space-between'>
        <ArcText.h5> Route </ArcText.h5>
        <ArcText.h6 
          color='brand' 
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate(`${routesConfig.orders}/update-mission/${missionId}`)}> 
          Edit 
        </ArcText.h6>
      </ArcStack>
      <ArcStack direction='row' spacing={1}>
        <ArcCellInfo label='Takeoff Altitude' width='50%'>
          {arcSpatium(Number(takeOffWp?.altitude))}
        </ArcCellInfo>
        <ArcCellInfo label='Destination Altitude' width='50%'> 
          {arcSpatium(Number(orderWp?.altitude))}
        </ArcCellInfo>
      </ArcStack>

      <ArcStack direction='row' spacing={1}>
        <ArcCellInfo label='Delivery Altitude' width='50%'>
          {arcSpatium(Number(orderWp?.deliveryAltitude))}
        </ArcCellInfo>
        <ArcCellInfo label='Cruise Speed' width='50%'> 
          {arcVelocitas(Number(orderWp?.speed))}
        </ArcCellInfo>
      </ArcStack>

      <ArcStack direction='row' spacing={1}>
        <ArcCellInfo label='Delivery Mode' width='50%'>
          {order?.deliveryMode}
        </ArcCellInfo>
        <ArcCellInfo label='Drone Name' width='50%'> 
          {data?.drone?.name}
        </ArcCellInfo>
      </ArcStack>
    </ArcStack>
  );
};

export default RouteInfo;